<form [formGroup]="form">
  <div class="row">
    <div class="column twelve lg-two md-three sm-six text-center">
      <img [src]="thumbnail.url" alt="Uploaded Image Thumbnail" />
      <em class="caption block">{{ thumbnail.fileName }}</em>
    </div>

    <div class="column twelve lg-seven md-five sm-six margin-top-20">
      <div class="row">
        <div class="column ten lg-six margin-left-20">
          @if (thumbnail.uploadFailure || thumbnail.uploadSuccess) {
            <h3 class="text-center">
              {{ selectCategory.value }}
            </h3>
          }
          @if (thumbnail.uploadFailure || thumbnail.uploadSuccess) {
            <p class="text-center">
              {{ inputDescription.value }}
            </p>
          }
          @if (!thumbnail.uploadFailure && !thumbnail.uploadSuccess) {
            <ds-form-control-container
              [labelText]="'Category'"
              [control]="form.controls['selectCategory']"
            >
              <select
                (change)="onCategoryChange()"
                class="icon fill"
                formControlName="selectCategory"
              >
                <option value="" disabled></option>
                @for (category of categoryOptions; track category) {
                  <option [value]="category">{{ category }}</option>
                }
              </select>
              <span class="icon-chevron-down"></span>
            </ds-form-control-container>
          }
        </div>
      </div>
      <div class="row">
        @if (
          !showDescription &&
          !thumbnail.uploadFailure &&
          !thumbnail.uploadSuccess &&
          selectCategory.value !== 'Other'
        ) {
          <a
            (click)="addDescription()"
            class="caption margin-top-20 margin-left-20 font-weight-semibold"
            dsContent
            [contentPath]="'claims.photoUpload.photoListAddDescriptionText'"
          ></a>
        }
        <div class="column ten lg-eight margin-left-20">
          @if (
            (showDescription || selectCategory.value === 'Other') &&
            !thumbnail.uploadFailure &&
            !thumbnail.uploadSuccess
          ) {
            <div>
              <ds-form-control-container
                [labelText]="
                  selectCategory.value !== 'Other' ? 'Description' : 'Description (required)'
                "
                [control]="form.controls['inputDescription']"
              >
                <textarea
                  class="description-box"
                  [formControl]="form.controls['inputDescription']"
                  (keyup)="onDescriptionChange()"
                  maxlength="65"
                ></textarea>
                <ds-form-control-message
                  class="text-red margin-bottom-10"
                  [control]="form.controls['inputDescription']"
                ></ds-form-control-message>
              </ds-form-control-container>
              @if (showDescription && selectCategory.value !== 'Other') {
                <a
                  (click)="removeDescription()"
                  class="caption margin-top-20 font-weight-semibold"
                  dsContent
                  [contentPath]="'claims.photoUpload.photoListRemoveDescriptionText'"
                ></a>
              }
              <em class="caption float-right"
                >{{ inputDescription.value.length }} / 65 characters</em
              >
            </div>
          }
        </div>
      </div>
    </div>

    <div class="column twelve lg-three md-four margin-top-30">
      <div class="column twelve flex justify-flex-end">
        @if (thumbnail.uploadSuccess) {
          <p class="caption margin-bottom-10 margin-right-30 flex">
            <span class="icon-complete-circle margin-right-10"></span>
            <span>Success</span>
          </p>
        }
        @if (thumbnail.uploadFailure && !thumbnail.uploadInProgress) {
          <p class="caption margin-bottom-10 margin-right-30 flex">
            <span class="icon-alert margin-right-10"></span>
            <span>Upload failed</span>
          </p>
        }
      </div>
      @if (!thumbnail.uploadInProgress) {
        <div class="column twelve text-right">
          @if (thumbnail.uploadFailure && !missingData) {
            <button
              ds-button
              (click)="retryUpload()"
              class="-outline-white pad-left-20 pad-right-20 margin-right-20"
            >
              Retry
            </button>
          }
          @if (!thumbnail.uploadSuccess && !thumbnail.uploadInProgress) {
            <a
              (click)="remove()"
              class="color-red font-weight-semibold margin-top-10 margin-right-30"
              dsContent
              [contentPath]="'claims.photoUpload.photoListRemoveBtn'"
            ></a>
          }
        </div>
      }
      <div class="column twelve text-center">
        @if (thumbnail.uploadInProgress) {
          <ds-progress-indicator-circle
            [percent]="thumbnail.uploadPercent"
            [templateOptions]="progressIndicatorOptions"
          ></ds-progress-indicator-circle>
        }
      </div>
    </div>
  </div>
</form>
<hr aria-hidden="true" />
